import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_SIMPLE_CLIENT = "GET_SIMPLE_CLIENT";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Client/GetSimpleClient`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_SIMPLE_CLIENT, service, mock);
